import AppLayout from '../components/AppLayout';
import WorkspaceCanvas from '../components/WorkspaceCanvas';

const Home = () => {
  return (
    <AppLayout>
      <WorkspaceCanvas />
    </AppLayout>
  );
};

export default Home;
